import { Directive } from '@angular/core';
@Directive({
  selector: '[fEntityContainer]'
})
export class EntityContainerDirective {}
